import { c as _c } from "react/compiler-runtime";
import { publishEvent, TrackImpression } from '@udemy-v2/event-tracking';
import { useMatchMedia } from '@udemy-v2/design-system-utils';
import { useI18n } from '@udemy-v2/i18n';
import { Image } from '@udemy-v2/react-core-components';
import classNames from 'classnames';
import React from 'react';
import { CodingExercisePromotionImpressionEvent, CodingExercisePromotionImageClickEvent } from './events';
import { CodingExerciseModalTrigger } from './coding-exercise-promotion-modal.react-component';
import styles from './coding-exercise-promotion.module.scss';
import desktopPreviewImg from './assets/coding-exercises-demo-preview-desktop.png';
import mobilePreviewImg from './assets/coding-exercises-demo-preview-mobile.png';
export const enum CodingExercisePromotionLayouts {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
}
export interface CodingExercisePromotionProps {
  courseId: number;
  frontendTrackingId: string;
  layout?: CodingExercisePromotionLayouts;
}
export const CodingExercisePromotion = t0 => {
  const $ = _c(50);
  const {
    layout,
    courseId,
    frontendTrackingId
  } = t0;
  const {
    gettext
  } = useI18n();
  const isMobileMax = useMatchMedia("sm-max");
  const previewImage = isMobileMax ? mobilePreviewImg : desktopPreviewImg;
  const trackingId = frontendTrackingId;
  const resolvedLayout = layout ?? (isMobileMax ? CodingExercisePromotionLayouts.VERTICAL : CodingExercisePromotionLayouts.HORIZONTAL);
  const t1 = resolvedLayout === CodingExercisePromotionLayouts.HORIZONTAL;
  let t2;
  if ($[0] !== t1) {
    t2 = classNames(styles["coding-exercise-container"], {
      [styles["coding-exercise-container-horizontal"]]: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = {
      className: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const containerProps = t3;
  let t4;
  if ($[4] !== courseId || $[5] !== trackingId) {
    t4 = () => {
      publishEvent(new CodingExercisePromotionImpressionEvent({
        id: courseId,
        trackingId
      }));
    };
    $[4] = courseId;
    $[5] = trackingId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleImpression = t4;
  let t5;
  if ($[7] !== gettext) {
    t5 = gettext("Coding Exercises");
    $[7] = gettext;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <h2 className="ud-heading-xl">{t5}</h2>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = classNames("ud-text-sm", styles["coding-exercise-description"]);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== gettext) {
    t8 = gettext("This course includes our updated coding exercises so you can practice your skills as you learn.");
    $[12] = gettext;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <p className={t7}>{t8}</p>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== gettext) {
    t10 = gettext("Coding Exercise Demo");
    $[16] = gettext;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== gettext) {
    t11 = gettext("See a demo");
    $[18] = gettext;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== courseId || $[21] !== t10 || $[22] !== t11 || $[23] !== trackingId) {
    t12 = <CodingExerciseModalTrigger assetTitle={t10} assetId={48073474} courseId={courseId} ctaText={t11} trackingId={trackingId} />;
    $[20] = courseId;
    $[21] = t10;
    $[22] = t11;
    $[23] = trackingId;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t6 || $[27] !== t9) {
    t13 = <div className={styles["coding-exercise-content"]}>{t6}{t9}{t12}</div>;
    $[25] = t12;
    $[26] = t6;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== gettext) {
    t14 = gettext("This image is also treated as a button to track image enlargement interest");
    $[29] = gettext;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== gettext) {
    t15 = gettext("Image of coding exercise example");
    $[31] = gettext;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== courseId || $[34] !== trackingId) {
    t16 = () => {
      publishEvent(new CodingExercisePromotionImageClickEvent({
        id: courseId,
        trackingId
      }));
    };
    $[33] = courseId;
    $[34] = trackingId;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== previewImage.height || $[37] !== previewImage.src || $[38] !== previewImage.width || $[39] !== t14 || $[40] !== t15 || $[41] !== t16) {
    t17 = <div className={styles["coding-exercise-image-container"]}><Image className={styles["coding-exercise-image"]} role="button" aria-label={t14} alt={t15} src={previewImage.src} width={previewImage.width} height={previewImage.height} onClick={t16} /></div>;
    $[36] = previewImage.height;
    $[37] = previewImage.src;
    $[38] = previewImage.width;
    $[39] = t14;
    $[40] = t15;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== containerProps || $[44] !== t13 || $[45] !== t17) {
    t18 = <div {...containerProps}>{t13}{t17}</div>;
    $[43] = containerProps;
    $[44] = t13;
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== handleImpression || $[48] !== t18) {
    t19 = <TrackImpression trackFunc={handleImpression}>{t18}</TrackImpression>;
    $[47] = handleImpression;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  return t19;
};